export const BENCHMARKING_COLOUR_VARIABLES = {
    ELITE: '#0149c2',
    ABOVE_AVERAGE: '#02ae78',
    AVERAGE: '#f9ae2c',
    BELOW_AVERAGE: '#f15a26'
};
